import Lottie from "lottie-react";
import React from "react";
import animationData from "../../assets/animations/smart_sort_animation.json";
import { Stack, Typography } from "@mui/material";

const SmartSortAnimation = () => {
  return (
    <Stack
      gap="12px"
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Lottie
        animationData={animationData}
        loop
        autoplay
        style={{ width: 135.753, height: 131 }}
      />
      <Typography variant="caption">
        Applying smart filter to CPT codes
      </Typography>
    </Stack>
  );
};

export default SmartSortAnimation;
